<template>
    <div :class="[ask.no?'check_choose borTop':'check_choose']">
        <div :class="[Number(number)||Number(number)===0?'choose_title padding':'choose_title']">
            <p v-html="ask.question_title"
               v-if="ask.question_title"></p>
            <p :class="{'stem':ask.question_title}"
               v-if="ask.content"
               v-html="ask.content"></p>
            <p v-if="ask.image"><img :src="ask.image"></p>
            <!-- <span class="tit_num" v-if="Number(number)">{{number}}、</span> -->
            <span class="tit_num"
                  v-if="Number(number)===0">{{ask.no}}</span>
        </div>
        <!-- <div class="showBtn" @click="showBtn" v-if="mytask!=1">{{showBtnCon}}<i :class="{'icon_bottom':!chooseShowBtn,'icon_top':chooseShowBtn}"></i></div> -->
        <!-- <template v-if="!!checked">
			<div :class="[item_sub.option===ask.user_answer?'choose_opation inspect_myColor clearfix':'choose_opation clearfix']" v-for="(item_sub,index_sub) in ask.options" v-if="chooseShowBtn&&type!=7">
				<i class="option" v-html='item_sub.option'></i>
				<span style="background: transparent;" v-html='item_sub.content'></span>
				<p class="choose_img_pic" v-if="item_sub.image">
					<img :src="item_sub.image" alt="">
				</p>
			</div>
		</template> -->
        <template v-if="taskStatus">
            <div class="choose_opation clearfix"
                 :class="{'active':(item_sub.is_right),'userchoose':(ask.user_answer == item_sub.option&&!item_sub.is_right)}"
                 v-for="(item_sub,index_sub) in ask.options">
                <i class="option"
                   v-html='item_sub.option'></i>
                <span style="background: transparent;"
                      v-html='item_sub.content'></span>
                <p class="choose_img_pic"
                   v-if="item_sub.image">
                    <img :src="item_sub.image"
                         alt="">
                </p>
            </div>
        </template>
        <template v-else>
            <div class="choose_opation clearfix"
                 :class="{'active':(item_sub.is_right),'userchoose':(ask.user_answer == item_sub.option&&!item_sub.is_right)}"
                 v-for="(item_sub,index_sub) in ask.options">
                <i class="option"
                   v-html='item_sub.option'></i>
                <span style="background: transparent;"
                      v-html='item_sub.content'></span>
                <p class="choose_img_pic"
                   v-if="item_sub.image">
                    <img :src="item_sub.image"
                         alt="">
                </p>
            </div>
        </template>
        <div :class="[myColor?'refer_inspect_myColor':'refer_sentence']"
             v-if="type==7">
            <span class="refer_title">参考答案：</span>
            <div v-html="ask.reference"
                 v-if="ask.reference"></div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">

export default {
    data () {
        return {
            // showBtnCon:'展开选项',
            chooseShowBtn: false,
        }
    },
    components: {

    },
    props: ['ask', 'type', 'number', 'mystatus', "checked", 'myColor', 'status'],
    //mystatus 1是教师检查作业 展开选项不显示
    computed: {
        taskStatus () {
            return this.status ? 1 : 0;//1显示选择题绿色
        }
    },
    methods: {
        // showBtn(){
        // 	this.chooseShowBtn = !this.chooseShowBtn;
        // 	if(this.chooseShowBtn){
        // 		this.showBtnCon = '收起选项';
        // 	}else{
        // 		this.showBtnCon = '展开选项';
        // 	}
        // },
    },
    created () {

    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.check_choose {
    &.borTop {
        // border-top: 1px/$ppr solid #E8E8E8;
    }
    .choose_title {
        line-height: 48px / $ppr;
        font-size: 28px / $ppr;
        p {
            // padding: 32px/$ppr 24px/$ppr;
            // border-top: 1px/$ppr solid #E8E8E8;
            word-break: break-word;
            word-wrap: break-word;
            padding-bottom: 30px / $ppr;
        }
        &.padding {
            position: relative;
            .tit_num {
                // position: absolute;
                // top: 32px/$ppr;
                // left: 24px/$ppr;
            }
            p:first-child {
                // padding-left: 80px/$ppr;
            }
        }
    }
    .stem {
        line-height: 50px / $ppr;
        // border-top: 1px/$ppr solid #E8E8E8;
    }
    .choose_opation {
        // position: relative;
        // padding: 32px/$ppr 24px/$ppr 32px/$ppr 96px/$ppr;
        padding: 24px / $ppr;
        line-height: 48px / $ppr;
        color: #333;
        display: block;
        background: #f7f8f9;
        margin-bottom: 40px / $ppr;
        border-radius: 16px / $ppr;
        vertical-align: middle;
        &.active {
            color: #2bc8a0;
            background: #eefaf8;
            .option {
                border-radius: 1px solid #2bc8a0;
            }
            span {
                border-left: 1px solid #2bc8a0;
            }
        }
        &.userchoose {
            color: #ff5a5a;
            background: #fbf0ee;
            .option {
                border-radius: 1px solid #ff5a5a;
            }
            span {
                border-left: 1px solid #ff5a5a;
            }
        }
        .option {
            display: inline-block;
            width: 40px / $ppr;
        }
        span {
            display: inline-block;
            width: 460px / $ppr;
            padding-left: 30px / $ppr;
            vertical-align: middle;
            border-left: 1px solid #d0d3d6;
        }
    }
    .refer_sentence {
        padding: 30px / $ppr 0;
        line-height: 48px / $ppr;
        font-size: 28px / $ppr;
    }
    .refer_title {
        padding-bottom: 20px / $ppr;
        display: block;
    }
}
</style>
